import React, { FC } from 'react';
import cx from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';

import useCommonStyles from 'styles/common';
import CenterImage from 'components/common/CenterImage';

import winnerTitleImg from 'assets/winner-title.svg';
import { Tomato02, Milk03 } from 'components/home/stamps';

const useStyles = makeStyles((theme) => ({
	winnerSection: { 
		color: 'var(--color-tertiary)',
        marginTop: 36,
		padding: '0 16px',
		position: 'relative',
        [theme.breakpoints.down('xs')]: {
			'& h6': {
				fontSize: 36
			},
			'& p': {
				fontSize: 16
			},
		}
	},
	winnerSectionTitle: {
		maxWidth: 192,
        [theme.breakpoints.down('xs')]: {
			maxWidth: 160,
		}
	}
}));


interface Props {
  titleRef: React.RefObject<HTMLElement>;
}

const WinnerSection: FC<Props> = ({ titleRef }) => {
	const classes = useStyles();
	const common = useCommonStyles();

	return (<div className={ cx(common.columnCenter, common.fullWidth, classes.winnerSection) }>
		<Tomato02 style={{ top: 50, right: 'calc(50vw - 680px)', width: 40, transform: 'rotate(75deg)'}}/>
		<Milk03 style={{ bottom: -85, left: 'calc(50vw - 680px)'}} />
		<CenterImage src={winnerTitleImg} alt='winner-title' className={classes.winnerSectionTitle}/>

		<Tomato02 className={common.displayInMobile} style={{ top: -10, left: 30, width: 24, transform: 'rotate(65deg)'}}/>


		<Typography 
			variant="h1" style={{ marginTop: 24 }}
		>{`〔好侍紅白洋食對決◆發票登錄活動得獎名單〕`}</Typography> 

		<Typography 
			ref={ titleRef }
			variant="body1" style={{ marginTop: 16, color: 'var(--color-primary', fontWeight: 'bold'}}
		>{`投票由紅色獲勝！`}</Typography>
		
		<Typography 
			variant="body1" style={{ marginTop: 8, fontWeight: 'bold' }}
		>{`★日本九州熊本來回機票乙張(1名)`}</Typography> 
		<Typography 
			variant="body1" style={{ marginTop: 8 }}
		>{`陳○萍	0922****49`}</Typography> 

		<Typography 
			variant="body1" style={{ marginTop: 16, fontWeight: 'bold' }}
		>{`★【ZOJIRUSHI 象印】2024年新機型空中微波烘烤微波爐23L ES-JAF23(1名)`}</Typography> 
		<Typography 
			variant="body1" style={{ marginTop: 8 }}
		>{`劉○潔	0982****91`}</Typography> 

		<Typography 
			variant="body1" style={{ marginTop: 16, fontWeight: 'bold' }}
		>{`★【ZOJIRUSHI 象印】日本製 STAN. 美型IH 電子鍋6人份NW-SAF10】(1名)`}</Typography> 
		<Typography 
			variant="body1" style={{ marginTop: 8 }}
		>{`賴○傑	0909****93`}</Typography> 


		<Typography 
			variant="body1" style={{ marginTop: 16, fontWeight: 'bold' }}
		>{`★【FELLOW】Opus 錐刀磨豆機(1名)`}</Typography> 
		<Typography 
			variant="body1" style={{ marginTop: 8 }}
		>{`鍾○玲	0912****59`}</Typography> 


		<Typography 
			variant="body1" style={{ marginTop: 16, fontWeight: 'bold' }}
		>{`★【THERMOS】厚鑄耐摩不沾鍋_KFM_26cm & Masa親筆簽名最新食譜書(1名)`}</Typography> 
		<Typography 
			variant="body1" style={{ marginTop: 8 }}
		>{`周○佑	0937****45`}</Typography> 


		<Typography 
			variant="body1" style={{ marginTop: 16, fontWeight: 'bold' }}
		>{`★【THERMOS】真空保溫瓶 1200mlIS212系列 (不銹鋼色)`}</Typography> 
		<Typography 
			variant="body1" style={{ marginTop: 8 }}
		>{`曾○葳	0901****91`}</Typography> 

		<Typography 
			variant="h1" style={{ 
				marginTop: 24,
				paddingTop: 24,
				borderTop: '1px solid'
			}}
		>{`〔好侍紅白洋食對決◆投票應援活動得獎名單〕`}</Typography> 

		<Typography 
			variant="body1" style={{ marginTop: 8, fontWeight: 'bold' }}
		>{`★優勝加碼抽-全聯千元禮券+紅白雙醬料理塊(10名)`}</Typography> 
		<Typography
			variant="body1"
			style={{ whiteSpace: 'pre-line', marginTop: 8}}
		>
			{`洪○庭	0989****38
			蔡○華	0982****71
			李○威	0921****60
			陳○茿	0978****56
			鄭○霞	0981****92
			吳○玲	0906****28
			林○生	0932****93
			張○華	0952****77
			曾○菁	0956****56
			張○惠	0902****98`}
		</Typography> 

		<Typography 
			variant="body1" style={{ marginTop: 16, fontWeight: 'bold' }}
		>{`★敗部加碼抽-全聯五百元禮券+紅白雙醬料理塊(10名)`}</Typography> 
		<Typography
			variant="body1"
			style={{ whiteSpace: 'pre-line', marginTop: 8}}
		>
			{`楊○觀	0981****52
			陳○妙	0424****92
			曾○麗	0921****75
			陳○鴻	0910****90
			吳○雲	0960****91
			卓○喬	0921****51
			彭○君	0927****46
			呂○蘭	0929****50
			林○鈁	0908****68
			吳○雄	0915****85`}
		</Typography> 


	</div>);
};

export default WinnerSection;
